import React, { PureComponent } from 'react';

class GiftValue extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			selected: props.selectedValueInd === props.index,
		};

		this.handleClickGiftValue = this.handleClickGiftValue.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.selectedValueInd !== this.props.selectedValueInd) {
			this.setState({ selected: this.props.selectedValueInd === this.props.index });
		}
	}

	handleClickGiftValue(e) {
    	e.preventDefault();
    	this.props.changeGiftValueIndex(this.props.index);
    }


	render() {
		return (
			<div onClick={ this.handleClickGiftValue } className={this.state.selected ? "gift-value selected" : "gift-value"}>
				{ "$" + this.props.value }
			</div>
		);
	}
}

export default GiftValue;



// WEBPACK FOOTER //
// ./src/components/gift/GiftValue.js